import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 延迟渲染组件
 */
import { useEffect, useState } from 'react';
/**
 * 只在指定条件被满足时才开始渲染的组件, 使用场景通常是:
 * 有些组件渲染开销较大且初始不可见, 希望等到用户点击使用的时候才开始渲染, 比如某种全屏表格选择器
 *
 * @category Util Component
 * @param args - Argument object
 * @param args.renderWhen - 该值变为 true 时才开始渲染
 * @param args.children - React component children
 * @returns 已被延迟渲染的组件
 *
 * @example
 * ```html
 * <Lazy renderWhen={visible}><SomeComponent ... /></>
 * ```
 */
export const Lazy = ({ renderWhen = false, children, }) => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        if (renderWhen && !ready) {
            setReady(true);
        }
    }, [renderWhen, ready]);
    return ready ? _jsx(_Fragment, { children: children }, void 0) : null;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF6eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0xhenkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7R0FFRztBQUVILE9BQU8sRUFBRSxTQUFTLEVBQUUsUUFBUSxFQUFhLE1BQU0sT0FBTyxDQUFBO0FBRXREOzs7Ozs7Ozs7Ozs7OztHQWNHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLENBQUMsRUFDbkIsVUFBVSxHQUFHLEtBQUssRUFDbEIsUUFBUSxHQUlULEVBQUUsRUFBRTtJQUNILE1BQU0sQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLEdBQUcsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBRXpDLFNBQVMsQ0FBQyxHQUFHLEVBQUU7UUFDYixJQUFJLFVBQVUsSUFBSSxDQUFDLEtBQUssRUFBRTtZQUN4QixRQUFRLENBQUMsSUFBSSxDQUFDLENBQUE7U0FDZjtJQUNILENBQUMsRUFBRSxDQUFDLFVBQVUsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFBO0lBRXZCLE9BQU8sS0FBSyxDQUFDLENBQUMsQ0FBQyw0QkFBRyxRQUFRLFdBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFBO0FBQ3ZDLENBQUMsQ0FBQSJ9